import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { getFoodHistory } from 'features/food/foodSlice'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { BodyText, OtherText } from 'styling/Typography'
import { IFoodHistoryDayResponse } from 'types/api/foodApi.interface'
import { formatDateForDisplay } from 'utils/helpers'

const historyColumns: IHonestTableColumn<IFoodHistoryDayResponse & { id: string }>[] = [
  {
    id: 'operationalDay',
    header: 'Day',
    sticky: true,
    cell: (row) => <BodyText weight='600'>{formatDateForDisplay(row.operationalDay)}</BodyText>,
  },
  {
    id: 'windowsFinalized',
    header: 'Windows finalized',
    cell: (row) => row.windowsFinalized,
  },
  {
    id: 'mealsFinalized',
    header: 'Meals finalized',
    cell: (row) => row.mealsFinalized,
  },
  {
    id: 'expectedWaste',
    header: 'Expected waste',
    cell: (row) => row.expectedWaste,
  },
  {
    id: 'plateWaste',
    header: 'Plate waste',
    cell: (row) => row.plateWaste,
  },
  {
    id: 'openExceptions',
    header: 'Open exceptions',
    cell: (row) =>
      row.openExceptions ? (
        <OtherText>{row.openExceptions}</OtherText>
      ) : (
        <OtherText grey>0</OtherText>
      ),
  },
]

export const HistoryTab = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { historyDays, isLoading } = useSelector((store: RootState) => store.food)

  const range = useMemo(() => {
    const to = new Date()
    const from = new Date()
    from.setDate(from.getDate() - 30)
    const fmt = (d: Date) => {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
    return { from: fmt(from), to: fmt(to) }
  }, [])

  useEffect(() => {
    dispatch(getFoodHistory(range))
  }, [dispatch, range])

  const rows = (historyDays || []).map((row) => ({
    ...row,
    id: row.operationalDay,
  }))

  return (
    <HonestTable
      columns={historyColumns}
      data={rows}
      keyField='id'
      loading={isLoading}
      emptyMessage='No finalized operational days in the last 30 days'
    />
  )
}
